import tw from "twin.macro";

export const Spacing24 = tw.div`h-24`;
